import * as angular from 'angular';
import { ClAutofocusDirective } from './Autofocus/ClAutofocusDirective';
import { CapsLockDirective } from './CapsLock/CapsLockDirective';
import { ConvertToBooleanDirective } from './ConvertToNumber/ConvertToBoolean';
import { ConvertToNumberDirective } from './ConvertToNumber/ConvertToNumber';
import { StringToNumberDirective } from './ConvertToNumber/StringToNumber';
import { GridPagingDirective } from './DataGridView/GridPagingDirective';
import { ClDragDirective } from './DragDrop/ClDragDirective';
import { ClDropDirective } from './DragDrop/ClDropDirective';
import { EditableContentDirective } from './EditableContent/EditableContentDirective';
import { IgnoreDirtyDirective } from './IgnoreDirty/IgnoreDirtyDirective';
import { InvalidIfDirective } from './InvalidIf/InvalidIfDirective';
import { NoWheelDirective } from './NoWheel/NoWheelDirective';
import { OnEnterKeyDirective } from './OnEnterKey/OnEnterKeyDirective';
import propertyDataListDirective from './PropertyDataList/PropertyDataListDirective';
import { ZeroPaddingDirective } from './ZeroPadding/ZeroPaddingDirective';

const directiveModule = angular.module('app.areas.common.directives', []);

directiveModule
    .directive(CapsLockDirective.$name, CapsLockDirective.Factory())
    .directive(ClAutofocusDirective.$name, ClAutofocusDirective.Factory())
    .directive('convertToBoolean', ConvertToBooleanDirective.Factory())
    .directive('convertToNumber', ConvertToNumberDirective.Factory())
    .directive(EditableContentDirective.$name, EditableContentDirective.Factory())
    .directive(IgnoreDirtyDirective.$name, IgnoreDirtyDirective.Factory())
    .directive(InvalidIfDirective.$name, InvalidIfDirective.Factory())
    .directive(NoWheelDirective.$name, NoWheelDirective.Factory())
    .directive('stringToNumber', StringToNumberDirective.Factory())
    .directive('propertyDataList', propertyDataListDirective)
    .directive(ZeroPaddingDirective.$name, ZeroPaddingDirective.Factory())
    .directive(ClDragDirective.$name, ClDragDirective.Factory())
    .directive(ClDropDirective.$name, ClDropDirective.Factory())
    .directive('gridPager', GridPagingDirective.Factory())
    .directive(OnEnterKeyDirective.$name, OnEnterKeyDirective.Factory());

export default directiveModule.name;
